// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResultRow-cls1_gq6","cls2":"AutoCompleteResultRow-cls2_kJg AutoCompleteResultRow-cls1_gq6"};